module.exports = __webpack_public_path__ + "static/media/PuertoVallarta.5ddcefa9.jpg";